import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { Grid } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { dataViewActions } from '../../../../behavior/dataview';
import { wrapConsumer } from '../../../Filtering/FilteringContextProvider';
import { entityType as et } from '../../../../constants';
import { reportsActions } from '../../../../behavior/reports';
import {
  GET_CSV_FORMAT,
  GET_SELECTED_INVENTORIES_REPORT_PATH,
} from '../../../../behavior/reports/types';
import { filterActions } from '../../../../behavior/filter';
import { inventoriesActions } from '../../../../behavior/inventories';
import { gridTemplatesOptions } from '../../../../objects/StickerGridTemplate';
import MarkInetoryCheckedPopup from './Components/MarkInventoryCheckedPopup';
import BatchUpdateButton from './Components/BathUpdateButton';
import ExportDropdown from './Components/ExportDropdown';
import DataViewInputFields from './Components/DataViewInputFields';
import AddNewRecord from './Components/AddNewRecord';
import useUser from '@behavior/init/getUserV2';
import {
  isAdmin,
  isChemicalSafetyExpert,
  isDSO,
  isEditor,
  isEnvironmentalExpert,
} from '@behavior/init/selectors';
import { connect } from 'react-redux';

type Props = {
  formikProps: any;
  isRenderExport: boolean;
  dataViewList: any[];
  createdDataView: any;
  handleChangeDataView: (arg0: string) => void;
  handleFilterStateChanged: () => void;
  handleAddNewRecord: () => void;
  selectedRows: any;
  history: any;
  filterState: any;
  inventoryState: any;
  allFilters: any;
  actions: any;
  entityType: string;
  isReportLoading: boolean;
  shareUrl: string;
  location: any;
};

const ViewOptionsContainer = ({
  formikProps,
  isRenderExport,
  dataViewList,
  createdDataView,
  handleChangeDataView,
  handleFilterStateChanged,
  handleAddNewRecord,
  selectedRows,
  history,
  filterState,
  inventoryState,
  allFilters,
  actions,
  entityType,
  isReportLoading,
  shareUrl,
  location,
}: Props) => {
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    //refreshing inventory page after checking selected inventories
    if (inventoryState.checked === true) {
      handleFilterStateChanged();
    }
  }, [inventoryState]);

  useEffect(() => {
    if (inventoryState.checked && filterState.filterValues) {
      actions.applyFilterAction(et.inventory, filterState, filterState.filterValues);
    }
  }, [inventoryState.checked]);

  return entityType === et.inventory || entityType === et.product ? (
    <Grid>
      <Grid.Row>
        <Grid.Column mobile={16} tablet={6} computer={6}>
          <AddNewRecord entityType={entityType} handleAddNewRecord={handleAddNewRecord} />
          {entityType === et.inventory &&
            (isEditor(user) ||
              isAdmin(user) ||
              isDSO(user) ||
              isEnvironmentalExpert(user) ||
              isChemicalSafetyExpert(user)) && (
              <>
                <MarkInetoryCheckedPopup actions={actions} selectedRows={selectedRows} />
                <BatchUpdateButton history={history} />
              </>
            )}
          <ExportDropdown
            isRenderExport={isRenderExport}
            isReportLoading={isReportLoading}
            selectedRows={selectedRows}
            gridTemplatesOptions={gridTemplatesOptions}
            actions={actions}
            filterState={filterState}
            allFilters={allFilters}
            entityType={entityType}
          />
        </Grid.Column>

        <Grid.Column computer={10} only="computer tablet" textAlign="right">
          <DataViewInputFields
            isCreatingNew={isCreatingNew}
            actions={actions}
            location={location}
            entityType={entityType}
            filterState={filterState}
            shareUrl={shareUrl}
            dataViewList={dataViewList}
            handleChangeDataView={handleChangeDataView}
            formikProps={formikProps}
            setIsCreatingNew={setIsCreatingNew}
            history={history}
            inventoriesActions={inventoriesActions}
          />
        </Grid.Column>
        <Grid.Column mobile={16} only="mobile">
          <DataViewInputFields
            isCreatingNew={isCreatingNew}
            actions={actions}
            location={location}
            entityType={entityType}
            filterState={filterState}
            shareUrl={shareUrl}
            dataViewList={dataViewList}
            handleChangeDataView={handleChangeDataView}
            formikProps={formikProps}
            setIsCreatingNew={setIsCreatingNew}
            history={history}
            inventoriesActions={inventoriesActions}
            createdDataView={createdDataView}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  ) : (
    <></>
  );
};

ViewOptionsContainer.defaultProps = {
  isRenderExport: false,
};

const mapStateToProps = (state: any) => ({
  allFilters: state.filter,
  shareUrl: state.dataView.shareUrl,
  isReportLoading: state.reports.isReportLoading,
  createdDataView: state.dataView.createdDataView,
  isLoadingGetShareUrl: state.dataView.isLoadingGetShareUrl,
  inventoryState: state.inventories,
});

const mapDispatchToProps = (dispatch: any) => ({
  actions: {
    createNewDataView: (dataViewName: string, entityType: string, filterState: any, filters: any) =>
      dispatch(dataViewActions.createNewDataView(dataViewName, entityType, filterState, filters)),
    getDataViewList: (entityType: string) => dispatch(dataViewActions.getDataViewList(entityType)),
    deleteDataView: (id: string, entityType: string) =>
      dispatch(dataViewActions.deleteDataView(id, entityType)),
    lockUnlockDataView: (id: string, entityType: string) =>
      dispatch(dataViewActions.lockUnlockDataView(id, entityType)),
    favoriteUnfavoriteDataView: (id: string, entityType: string) =>
      dispatch(dataViewActions.favoriteUnfavoriteDataView(id, entityType)),
    getShareUrlDataView: (
      newDataViewName: string,
      id: string,
      entityType: string,
      filterState: any,
      filters: any
    ) =>
      dispatch(
        dataViewActions.getShareUrlDataView(newDataViewName, id, entityType, filterState, filters)
      ),
    shareDataView: (newDataViewName: string, sharedDataView: string, entityType: string) =>
      dispatch(dataViewActions.shareDataView(newDataViewName, sharedDataView, entityType)),
    getInventoryReport: (
      ids: string[],
      format: string,
      filters: string,
      filterState: string,
      language: string
    ) => {
      if (format == GET_CSV_FORMAT) {
        dispatch(reportsActions.getCsvReport(ids, filters, filterState, language));
      } else {
        dispatch(
          reportsActions.getReport(
            `${GET_SELECTED_INVENTORIES_REPORT_PATH + format}?useExcelTemplate=true`,
            ids
          )
        );
      }
    },
    applyFilterAction: (entityType: string, filterState: string, filters: string) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters)),
    markAsChecked: (inventoryIds: string[]) =>
      dispatch(inventoriesActions.markAsChecked(inventoryIds)),
  },
});

export default withRouter(
  wrapConsumer(compose(connect(mapStateToProps, mapDispatchToProps))(ViewOptionsContainer))
);
